import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home';
import Features from './pages/Features';
import Unsubscribe from './pages/Unsubscribe';
import DevToolsProtector from './components/DevToolsProtector/DevToolsProtector';
import './App.css';

function App() {
  return (
    <DevToolsProtector>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </Router>
    </DevToolsProtector>
  );
}

export default App;
